import React, { FC, useState } from "react";
import { Box, Stack, Typography } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import { btn_value } from "./dashboard/data";
import BadgeImage from "./ui-elements/badge-image";
import { ArrowRight } from "./ui-elements/svg-icons";

import { useNotificationService } from "../hooks/notification";
import { RepresentativeDataList } from "../interface/representative";
import { PATH_DASHBOARD } from "../routes/path";
import { btnCover } from "./styles-ui";

import { apiGetRepresentativeList } from "../api/representative";
import useResponsive from "../hooks/useResponsive";
import { SkeletonRepsLoading } from "./ui-elements/skeleton-loading";
import useInfiniteScrollRepresentativeFetcher from "../hooks/useInfiniteScrollReps";
import { useSelector } from "react-redux";
import { RootState } from "../store/store";
import { AccountProfileData } from "../interface/account";

const initialParams = {
  page: 1,
  page_size: 10,
  search: "",
  state: "",
  local_government: "",
  position: "",
  sort_by: "asc",
  sort_order: "",
};

const RepresentativeContainer = ({
  accountProfileDetails,
}: {
  accountProfileDetails: AccountProfileData;
}) => {
  const isSmall = useResponsive("down", "sm", "xl");
console.log(accountProfileDetails)
  const { items, sentryRef, loading, updateParams } =
    useInfiniteScrollRepresentativeFetcher<RepresentativeDataList>({
      queryKey: "representative-data-list",
      fetchData: apiGetRepresentativeList,
      initialParams: {
        page_size: 10,
        search: "",
        state: accountProfileDetails?.state,
        local_government: "",
        position: "",
        sort_by: "",
        sort_order: "",
      },
    });

  const [selectedButtons, setSelectedButtons] = useState("All");

  const handleButtonClick = (value: string) => {
    setSelectedButtons(value);
    if (value === "All") {
      const param = { ...initialParams, position: "" };
      handleFilterChange(param);
      return;
    }
    //  update filter
    const param = { ...initialParams, position: value?.toLowerCase() };
    handleFilterChange(param);
  };
  // Example of updating search
  const handleSearchChange = (searchTerm: string) => {
    updateParams({ search: searchTerm });
  };

  // Example of updating multiple params
  const handleFilterChange = (filters: Partial<typeof initialParams>) => {
    updateParams(filters);
  };

  return (
    <Box
      sx={{
        border: "1px solid rgba(231, 235, 239, 1)",
        mt: 2,
        borderRadius: "8px",
        px: 2,
        minHeight: 250,
        height: "100%",
        overflowY: "auto",
        width: isSmall ? 300 : "100%",
      }}
    >
      <Typography sx={{ fontWeight: 500, mt: 2 }} variant="h6" color="black">
        Your representative
      </Typography>

      <Box sx={{ display: "flex", overflowX: "scroll", my: 2 }}>
        {btn_value?.map((item, index) => (
          <Box
            key={index}
            sx={{
              ...btnCover,
              backgroundColor: selectedButtons === item ? "#459173" : "#E2F1EB",
              color: selectedButtons === item ? "white" : "#637D92",
            }}
            onClick={() => handleButtonClick(item)}
          >
            <Typography
              variant="caption"
              sx={{ whiteSpace: "nowrap", lineHeight: "10px" }}
            >
              {item}
            </Typography>
          </Box>
        ))}
      </Box>

      <Box sx={{}}>
        {loading && items?.length === 0 && (
          <Box sx={{}}>
            {[...Array(3)].map((_, idx) => (
              <SkeletonRepsLoading key={idx} />
            ))}
          </Box>
        )}
        {!loading && items?.length === 0 && (
          <Box sx={{ mt: 5 }}>
            <Typography
              variant="h5"
              sx={{ fontWeight: 500, textAlign: "center" }}
            >
              No data found
            </Typography>
          </Box>
        )}
        {items?.map((reps, id) => (
          <RepresentativeCover
            key={id}
            id={reps?.id}
            image={""}
            name={reps.name}
            party={reps.party}
            position={reps.position}
            badge={2}
          />
        ))}
      </Box>
      {/* CircularProgress loader */}
      <div ref={sentryRef} style={{}}>
        {loading && (
          <Box sx={{}}>
            <SkeletonRepsLoading />
          </Box>
        )}
      </div>
    </Box>
  );
};

export default RepresentativeContainer;

const RepresentativeCover: FC<{
  image: any;
  name: string;
  party: string;
  position: string;
  badge: number;
  id: number; // Placeholder for representative ID
}> = ({ image, badge, name, party, position, id }) => {
  const navigate = useNavigate();
  const { showNotification } = useNotificationService();
  const verified = useSelector((state: RootState) => state.content.verified);

  const handleRepsNavigate = () => {
    if (!verified) {
      showNotification(
        "Account has not been verified, Access to Representative is restricted",
        "warning"
      );
      return;
    }

    // Navigate to representative page
    navigate(PATH_DASHBOARD.reps, {
      state: { representative_id: id },
    });
  };
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 3,
        my: 2,
      }}
    >
      {/* <Stack>
        <img
          src={"/assets/images/account/cover-bg.jpeg"}
          alt=""
          width={90}
          height={78}
        />
      </Stack> */}
      <Stack>
        <Stack direction={"row"} sx={{ gap: 1 }}>
          <Typography variant="body2" sx={{ fontWeight: 600 }} color="black">
            {name}
          </Typography>
          <BadgeImage badge={badge} />
        </Stack>
        <Typography variant="caption">{party}</Typography>
        <Typography variant="caption">{position}</Typography>
        <Stack
          direction={"row"}
          alignItems={"center"}
          spacing={1}
          sx={{ cursor: "pointer" }}
          onClick={handleRepsNavigate}
        >
          <Typography
            variant="caption"
            sx={{ textDecorationLine: "underline", color: "459173" }}
          >
            View profile
          </Typography>
          <ArrowRight />
        </Stack>
      </Stack>
    </Box>
  );
};
